import { EXTERIOR_MIN_HEIGHT, EXTERIOR_MAX_HEIGHT, EXTERIOR_MIN_WIDTH, EXTERIOR_MAX_WIDTH,
  GARAGE_MIN_HEIGHT, GARAGE_MAX_HEIGHT, GARAGE_MIN_WIDTH, GARAGE_MAX_WIDTH,
  INTERIOR_HEIGHTS, INTERIOR_WIDTHS } from "@/lib/catalog";

export const HARDWARE_OPTIONS = ["Smart lock lever", "Smart lock lever + pull bar", "Pull bar · mechanical lock", "Pull bar · integrated smart lock"];
export const CUSTOM_FINISHES = {
  Interior: [{ id: "Forma", hint: "Melamine" }, { id: "Porto", hint: "Natural wood veneer" }, { id: "Siena", hint: "Painted MDF" }],
  Exterior: [{ id: "Toscana", hint: "Natural wood veneer" }, { id: "Monaco", hint: "Aluminum-clad" }, { id: "Milano", hint: "Melamine" }],
};
export const boundsFor = (category) => category === "Garage"
  ? { minWidth: GARAGE_MIN_WIDTH, maxWidth: GARAGE_MAX_WIDTH, minHeight: GARAGE_MIN_HEIGHT, maxHeight: GARAGE_MAX_HEIGHT }
  : { minWidth: EXTERIOR_MIN_WIDTH, maxWidth: EXTERIOR_MAX_WIDTH, minHeight: EXTERIOR_MIN_HEIGHT, maxHeight: EXTERIOR_MAX_HEIGHT };

export function defaultConfiguration(model) {
  return { height: model?.category === "Interior" ? INTERIOR_HEIGHTS[1] : "84",
    width: model?.category === "Interior" ? INTERIOR_WIDTHS[4] : model?.category === "Garage" ? "96" : "36",
    qty: 1, hardware: HARDWARE_OPTIONS[0], customFinish: model?.category === "Interior" ? "Forma" : "Toscana",
    doorType: model?.door_type || "Swing Door", wantMatch: false, matchHeight: "84", matchWidth: "36" };
}

function validateDimensions(width, height, category, prefix = "") {
  const b = boundsFor(category);
  if (!Number(height) || Number(height) < b.minHeight || Number(height) > b.maxHeight) return `${prefix}Height must be between ${b.minHeight}" and ${b.maxHeight}".`;
  if (!Number(width) || Number(width) < b.minWidth || Number(width) > b.maxWidth) return `${prefix}Width must be between ${b.minWidth}" and ${b.maxWidth}".`;
  return "";
}

export function validateConfiguration(model, form) {
  if (model.category === "Interior") {
    if (!INTERIOR_HEIGHTS.includes(form.height)) return "Please pick a standard height.";
    return INTERIOR_WIDTHS.includes(form.width) ? "" : "Please pick a standard width.";
  }
  return validateDimensions(form.width, form.height, model.category) ||
    (form.wantMatch ? validateDimensions(form.matchWidth, form.matchHeight, "Exterior", "Matching door ") : "");
}

export function configuredItems(model, f, refPhoto) {
  const category = model.category || "Exterior";
  const interior = category === "Interior";
  const custom = model.is_custom;
  const base = { category, series: custom ? f.customFinish : model.series,
    model_no: custom ? "Custom" : model.model_no,
    panel_style: custom ? `Design your own ${category}` : model.name, material: model.material,
    finish: custom ? f.customFinish : model.finish, color: "To be selected after estimate",
    hardware_collection: interior ? (f.doorType === "Sliding Door" ? "Premium Pull Handle" : "Premium Lever Handle")
      : category === "Exterior" ? f.hardware : model.hardware,
    hardware_finish: "To be selected after estimate", door_type: interior ? f.doorType : model.door_type,
    width: interior ? f.width : `${f.width}"`, height: interior ? f.height : `${f.height}"`, quantity: f.qty,
    image: custom && refPhoto?.isImage ? refPhoto.previewUrl : model.image, catalog_image: model.image,
    reference_photo_id: custom ? refPhoto?.id : undefined, reference_photo_name: custom ? refPhoto?.name : undefined };
  if (category !== "Garage" || !f.wantMatch) return [base];
  return [base, { ...base, category: "Exterior", series: model.series || "Matching Entrance",
    panel_style: `Matching Entrance Door — ${model.name}`, hardware_collection: "To be selected after estimate",
    door_type: "Entry Door", width: `${f.matchWidth}"`, height: `${f.matchHeight}"` }];
}